import type { AplicacaoDaApi } from './api';

/**
 * A APLICAÇÃO VALIDADA do item (migração 0088): em que modelo ou configuração
 * de máquina ele serve. Aviso, nunca bloqueio — a lista técnica e a peça da
 * O.S. respondem `semAplicacaoValidada` quando falta.
 */

/** As categorias que têm aplicação — as mesmas de `estoq.pede_aplicacao` (0088). */
export const CATEGORIAS_COM_APLICACAO: readonly string[] = ['peca', 'filtro', 'pneu', 'lubrificante'];

/** "CAT 320 · todas as configurações", ou a configuração. */
export function ondeServe(a: Pick<AplicacaoDaApi, 'fabricante' | 'modelo' | 'configuracao'>): string {
  const modelo = [a.fabricante, a.modelo].filter(Boolean).join(' ');
  return a.configuracao ? `${modelo} · configuração ${a.configuracao}` : `${modelo} · todas as configurações`;
}
